import * as $ from 'jquery';
import { getProductSlug } from './product-slug.service';

export class ProductsBreadCrumbs {

    static refresh(mainCategoryName?: string, mainCategoryUrl?: string, subCategoryName?: string) {
        const $items = $('ol.breadcrumb .breadcrumb-item');
        const homeUrl = $items.eq(0).find('a').attr('href');
        const homeName = $items.eq(0).find('span').text();

        const baseUrl = getProductSlug(); 
        const baseName = $items.eq(1).find('span').text();

        $items.remove();

        $('ol.breadcrumb').append(
            `<li class="breadcrumb-item"><a href="${homeUrl}"><span class="mdi mdi-chevron-right"></span><span>${homeName}</span></a></li>`);

        if (subCategoryName) {
            $('ol.breadcrumb').append(
                `<li class="breadcrumb-item"><a href="${homeUrl}/${baseUrl}"><span class="mdi mdi-chevron-right"></span><span>${baseName}</span></a></li>`);
            $('ol.breadcrumb').append(
                `<li class="breadcrumb-item"><a href="${homeUrl}/${baseUrl}/${mainCategoryUrl}"><span class="mdi mdi-chevron-right"></span><span>${mainCategoryName}</span></a></li>`);
            $('ol.breadcrumb').append(
                `<li class="breadcrumb-item active"><span><span class="mdi mdi-chevron-right"></span><span>${subCategoryName}</span></span></li>`);
        }
        else if (mainCategoryName) {
            $('ol.breadcrumb').append(
                `<li class="breadcrumb-item"><a href="${homeUrl}/${baseUrl}"><span class="mdi mdi-chevron-right"></span>${baseName}</a></li>`);
            $('ol.breadcrumb').append(
                `<li class="breadcrumb-item active"><span><span class="mdi mdi-chevron-right"></span><span>${mainCategoryName}</span></span></li>`);
        }
        else {
            $('ol.breadcrumb').append(
                `<li class="breadcrumb-item active"><span><span class="mdi mdi-chevron-right"></span><span>${baseName}</span></span></li>`);
        }

    }

}